import { IChildData } from "../../types/childDataTable"
import { IPlacementDataTable, IPlacementSubResult } from "../../types/placement"

export enum PlacementsActionType {
  FETCH_PLACEMENTS = "FETCH_PLACEMENTS",
  FETCH_PLACEMENTS_SUCCESS = "FETCH_PLACEMENTS_SUCCESS",
  FETCH_PLACEMENTS_ERROR = "FETCH_PLACEMENTS_ERROR",
}

interface FetchPlacements {
  type: PlacementsActionType.FETCH_PLACEMENTS
}

interface FetchPlacementsSuccess {
  type: PlacementsActionType.FETCH_PLACEMENTS_SUCCESS
  payload: IChildData
}

interface FetchPlacementsError {
  type: PlacementsActionType.FETCH_PLACEMENTS_ERROR
  payload: string
}

export type PlacementsAction = FetchPlacements | FetchPlacementsSuccess | FetchPlacementsError

export interface SponsoredProductState {
  childData: IChildData
  isLoading: boolean
  error: null | string
}

export interface IPlacementDataForUpdate {
  campaignId: number
  placements: IPlacementDataTable[]
}
